import React from 'react';
import { FaSearch } from 'react-icons/fa';

function SearchBar({ filter, setFilter }) {
  return (
    <div className="search-bar">
      <FaSearch className="search-icon" />
      <input
        type="text"
        placeholder="Pesquisar por ação, tema, patrocinador..."
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
      />
    </div>
  );
}

export default SearchBar; 